/**
 * SearchInput — token-driven search field with focus glow and clear button.
 *
 * Replaces ad-hoc `<div class="search-bar"><input /></div>` blocks.
 *
 *   <SearchInput
 *     value={query}
 *     onChange={(e) => setQuery(e.target.value)}
 *     onClear={() => setQuery('')}
 *     placeholder="Search by name, reg no, mother's no or GN division"
 *   />
 */
import React from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import './SearchInput.css';

export function SearchInput({
    value,
    onChange,
    onClear,
    placeholder = 'Search…',
    ariaLabel = 'Search',
    className = '',
    fullWidth = false,
    ...rest
}) {
    const showClear = Boolean(value) && typeof onClear === 'function';
    return (
        <div className={`pt-search ${fullWidth ? 'is-fullwidth' : ''} ${className}`}>
            <FiSearch size={16} className="pt-search__icon" aria-hidden="true" />
            <input
                type="text"
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
                aria-label={ariaLabel}
                className="pt-search__input"
                {...rest}
            />
            {showClear ? (
                <button
                    type="button"
                    onClick={onClear}
                    className="pt-search__clear"
                    aria-label="Clear search"
                >
                    <FiX size={14} />
                </button>
            ) : null}
        </div>
    );
}

export default SearchInput;
